module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_7016.3280d89f.png";